import React from 'react';
// import { Modal } from 'components';
//import ReactTooltip from 'react-tooltip';
// import { IconDelete } from '../../img';//IconInformation
// import ContentLoader from 'react-content-loader';
import Dropdown from 'react-dropdown';
// import Select from 'react-select';
import ContentLoader from 'react-content-loader';
import './Integration.scss';
import IntHeader from './IntHeader';
// const moment = require('moment');


// const brdSizeOption = [
//   { value: '0', label: '0px' },
//   { value: '1', label: '1px' },
//   { value: '2', label: '2px' },
//   { value: '3', label: '3px' },
//   { value: '4', label: '4px' },
//   { value: '5', label: '5px' },
//   { value: '6', label: '6px' },
// ];

// const TableRow = props => {
//   return (
//     <ContentLoader
//       height={50}
//       width={1208}
//       speed={3}
//       primaryColor="#eceef4"
//       secondaryColor="#fff"
//       {...props}
//     >
//       <rect x="0" y="15" rx="4" ry="4" width="10" height="10" />
//       <rect x="150" y="13" rx="6" ry="6" width="270" height="20" />
//       <rect x="470" y="13" rx="6" ry="6" width="420" height="20" />
//       <rect x="925" y="13" rx="6" ry="6" width="250" height="20" />
//     </ContentLoader>
//   );
// };

// const TableRows = props => {
//   return (
//     <ContentLoader
//       height={50}
//       width={1208}
//       speed={3}
//       primaryColor="#eceef4"
//       secondaryColor="#fff"
//       {...props}
//     >
//       <rect x="0" y="15" rx="4" ry="4" width="10" height="10"></rect>
//       <rect x="75" y="13" rx="6" ry="6" width="150" height="20"></rect>
//       <rect x="245" y="13" rx="6" ry="6" width="220" height="20"></rect>
//       <rect x="485" y="13" rx="6" ry="6" width="285" height="20"></rect>
//       <rect x="795" y="13" rx="6" ry="6" width="240" height="20"></rect>
//       <rect x="1060" y="13" rx="6" ry="6" width="120" height="20"></rect>
//     </ContentLoader>
//   );
// };

const GoogleReview = ({
  hideShowDataSource,
  userIntegration,
  data,
  // handleIsActive,
  //arrDataSource,
  //handleDataSource,
  createGMBPageReview,
  deletePageReview,
  deleteGMBReview,
  profile,
  // state,
  loading,
  // syncLastestPages,
  //handleStateChangeInt,
  openReviewModel,
  intInterValFn,
  disableOnCreateInt
}) => {

  let disableBTN = false;
  if (loading === true) {
    disableBTN = true;
  }
  else if (data.isCreatingIntegration === true) {
    disableBTN = data.isCreatingIntegration;
  }

  const redirectGGL = () => {
    disableOnCreateInt();
    let currentURL = window.location.href.replace(/&/gi, '@');
    let objStateGGL = {
      uk: profile._id,
      ti: profile.ti,
      uri: currentURL + '@tb=ds',//window.location.href,
      path: window.location.pathname
    };
    // localStorage.setItem('W_WDGT_CRT', JSON.stringify({
    //   wdsc: state.wdsc,
    //   widgetById: state.widgetById,
    //   currLayoutId: state.currLayoutId,
    //   currCardId: state.currCardId,
    //   currHtnpp: state.currHtnpp,
    //   isEditWidget: state.isEditWidget,
    // }));
    let redirect_uri = process.env.REACT_APP_INT_API_URL;
    //let redirect_uri = 'http://104.155.213.239/api';
    let authURL = 'https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A//www.googleapis.com/auth/business.manage&access_type=offline&prompt=consent&include_granted_scopes=true&response_type=code&state=' + JSON.stringify(objStateGGL) + '&redirect_uri=' + redirect_uri + '/gmb/oauth&client_id=587152220735-k6b4ir39gvk5ji7pmnedntil7slnr56f.apps.googleusercontent.com';
    window.open(authURL, '_self');
  };


  // userIntegration = userIntegration && userIntegration.length > 0 && userIntegration.filter(x => x.inm == 'googlemybusiness');
  if (userIntegration && userIntegration.length > 0) {
    userIntegration.filter(x => {
      if (x.inm === 'googlemybusiness') {
        if (x.d && x.d.lc && x.d.lc.length > 0) {
          let chkFilter = x.d.lc.filter(y => y.isListen === true && y.ia === true);
          if (chkFilter && chkFilter.length > 0 && data.isCallInterVal === false) {
            intInterValFn();
          }
        }
        return x;
      }
    });
  }
  return (
    <div>
      <div className="title-dataset-select">
        {/* <div className="dataset-select-header" >
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
            <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
          </svg>
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
       
        </div> */}
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        <div className="integr-inside-hdright wdgt-dataset-form" style={{ width: '100%' }}>
          <div className="add-integra-btn">
            <button className="nf-btn nf-btn-default" disabled={disableBTN} onClick={() => redirectGGL()}>Login with Google</button>
          </div>
        </div>
      </div>
      {/* {userIntegration && userIntegration.length > 0 && <div className="integre-search--list">
        <input
          className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
          placeholder="Search by name"
          type="text"
          name="searchByName"
          value={data.searchByName}
          onChange={(e) => handleStateChangeInt(e)}
        />
      </div>} */}
      {
        // data.islstIntLoading === true ?
        //   <ContentLoader
        //     height={750}
        //     width={1750}
        //     speed={2}
        //     primaryColor="#fff"
        //     secondaryColor="#eceef4"
        //   >
        //     <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
        //   </ContentLoader>
        //   :
        loading === true ?
          <ContentLoader
            height={750}
            width={1750}
            speed={2}
            primaryColor="#fff"
            secondaryColor="#eceef4"
          >
            <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
          </ContentLoader> :
          userIntegration && userIntegration.length > 0 ?
            userIntegration.map((usInt, key) => {
              // let dataArrLc = [];
              // if (usInt.d && usInt.d.lc && usInt.d.lc.length > 0) {
              //   dataArrLc = usInt.d.lc;
              //   if (data.searchByName) {
              //     dataArrLc = usInt.d.lc.filter(x => {
              //       if (new RegExp(data.searchByName, 'i').test(x.locationName) == true) {
              //         return x;
              //       } else if (!data.searchByName) {
              //         return x;
              //       }
              //     });
              //   }
              // }

              let intPages = [];
              if (usInt.d && usInt.d.lc && usInt.d.lc.length > 0) {
                for (let i = 0; i < usInt.d.lc.length; i++) {
                  const element = usInt.d.lc[i];
                  if (!element.ia) {
                    intPages.push({
                      value: element.name, label: element.locationName
                    });
                  }
                }
              }

              // if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
              return (<div className="integre-block-part">
                <div className="card-editor card-intigra-block mt-25 app-list-sublistapp sublistapp-p20" key={key}>
                  <div className="app-list-sublistapp-header">
                    <label className="card-editor-title app-intigra-title">{usInt.d && usInt.d.acn ? usInt.d.acn : ''}
                      <svg style={{ marginLeft: '10px' }} xmlns="http://www.w3.org/2000/svg" width='16' height='14' id="Group_8337" data-name="Group 8337" viewBox="0 0 120 120">
                        <path id="Path_12794" data-name="Path 12794" d="M119.034,48.893a.966.966,0,0,1,.966.966V60a60,60,0,1,1-18.278-43.121.968.968,0,0,1,.016,1.382L87.392,32.608a.963.963,0,0,1-1.345.019,37.782,37.782,0,1,0,10.078,38.48H60.966A.966.966,0,0,1,60,70.141V49.859a.966.966,0,0,1,.966-.966h58.068Z" transform="translate(0)" fill="#2196f3" />
                        <g id="Group_8336" data-name="Group 8336" transform="translate(56.374 48.893)">
                          <path id="Path_12795" data-name="Path 12795" d="M303.191,208.612h-7.243a.966.966,0,0,1,.966.966v10.141a59.95,59.95,0,0,1-56.382,59.892q1.59.094,3.2.107a59.952,59.952,0,0,0,60.423-60V209.578A.966.966,0,0,0,303.191,208.612Z" transform="translate(-240.531 -208.612)" fill="#1e88e5" />
                        </g>
                        <path id="Path_12796" data-name="Path 12796" d="M50.034,44.175,31.812,31.009a60.014,60.014,0,0,1,94.266-14.13.968.968,0,0,1,.016,1.382L111.748,32.608a.962.962,0,0,1-1.343.021A37.794,37.794,0,0,0,50.034,44.175Z" transform="translate(-24.356 0)" fill="#f44336" />
                        <path id="Path_12797" data-name="Path 12797" d="M87.115,112.938l5.261,3.8a37.807,37.807,0,0,1,30.391-21.756c.1-.011.2-.024.3-.034q-1.785-.169-3.615-.172a37.674,37.674,0,0,0-32.339,18.161Z" transform="translate(-66.697 -72.564)" fill="#e53935" />
                        <path id="Path_12798" data-name="Path 12798" d="M278.646,16.879a.968.968,0,0,1,.016,1.382L267.018,29.906a37.966,37.966,0,0,1,3.2,2.721.963.963,0,0,0,1.345-.019l14.346-14.346a.969.969,0,0,0-.016-1.382A59.816,59.816,0,0,0,244.167,0c-1.217,0-2.424.041-3.622.112A59.808,59.808,0,0,1,278.646,16.879Z" transform="translate(-184.167 0)" fill="#e53935" />
                        <path id="Path_12799" data-name="Path 12799" d="M124.67,342.79a60.01,60.01,0,0,1-97.69-13.941l18.6-12.749a37.792,37.792,0,0,0,60.865,13.526Z" transform="translate(-20.657 -242.014)" fill="#4caf50" />
                        <path id="Path_12800" data-name="Path 12800" d="M88.436,316.1,82.95,319.86A37.781,37.781,0,0,0,116.265,339.8c1.219,0,2.424-.06,3.613-.172A37.817,37.817,0,0,1,88.436,316.1Z" transform="translate(-63.509 -242.015)" fill="#43a047" />
                        <path id="Path_12801" data-name="Path 12801" d="M244.2,438.669a59.834,59.834,0,0,0,44.014-19.224l-4.463-3.224a59.892,59.892,0,0,1-43.163,22.339Q242.379,438.666,244.2,438.669Z" transform="translate(-184.199 -318.669)" fill="#43a047" />
                        <path id="Path_12802" data-name="Path 12802" d="M22.213,161.3a37.673,37.673,0,0,0,2.714,14.086l-18.6,12.748a60.095,60.095,0,0,1,1.132-55.825l18.222,13.166A37.631,37.631,0,0,0,22.213,161.3Z" transform="translate(0 -101.297)" fill="#ffc107" />
                        <path id="Path_12803" data-name="Path 12803" d="M68.343,209.736l5.486-3.759a37.891,37.891,0,0,1,.751-29.911l-5.261-3.8a37.966,37.966,0,0,0-.976,37.471Z" transform="translate(-48.901 -131.89)" fill="#ffb300" />
                      </svg>

                    </label>
                    <div className="app-sublistapp-actiontop">
                      {/* <div className="btn-action nf-btn light-bg-icon btn-icon-20 mr-3" onClick={() => syncLastestPages(usInt._id)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 25.292 32.141">
                        <g id="Group_8471" data-name="Group 8471" transform="translate(-9.074)">
                          <path fill="#8fa7c4" id="Path_14194" data-name="Path 14194" d="M42.315,15l-1.557,1.682a10.423,10.423,0,0,1-6.272,19.133l.411-.432h-.025l1.558-1.635-1.439-1.373L31.9,35.618h0l-1.333,1.4,1.438,1.372h0l3.243,3.09,1.334-1.4-2.1-2A12.685,12.685,0,0,0,42.315,15Z" transform="translate(-13.382 -9.339)" />
                          <path fill="#8fa7c4" id="Path_14195" data-name="Path 14195" d="M11.467,14.454a10.425,10.425,0,0,1,10.87-8.789l-.411.432h.025L20.392,7.732l1.439,1.373,3.09-3.244h0l1.333-1.4L24.817,3.09h0L21.573,0,20.239,1.4l2.1,2a12.686,12.686,0,0,0-7.832,23.08L16.064,24.8A10.441,10.441,0,0,1,11.467,14.454Z" />
                        </g>
                      </svg>
                    </div> */}
                      {/* <label className="switch">
                      <input type="checkbox"
                        checked={usInt.ia ? true : false}
                        onChange={(e) => handleIsActive(usInt._id, e.target.checked)}
                      />
                      <span className="slider round"></span>
                    </label> */}
                      <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deleteGMBReview(usInt._id)}>
                        <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                          <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                          <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                          <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='app-list-sublistapp-select' style={{ margin: '10px 0px' }}>
                    <Dropdown
                      options={intPages}
                      className="nf-select-dropdown nf-select-defaultdd"
                      placeholder="Select an pages"
                      onChange={(e) => createGMBPageReview({ name: e.value, _id: usInt._id })}
                    />
                  </div>
                  <div className='integra-data-headerblock' style={{ marginTop: '15px' }}>
                    <label className=''>Name</label>
                    <label className=''>Action</label>
                  </div>
                  <div className="card-intigra-box review-collection-scroll" style={{ height: 'calc(100vh - 890px)' }}>
                    {usInt.d && usInt.d.lc && usInt.d.lc.length > 0 && usInt.d.lc.filter(x => x.ia === true).length > 0 ? usInt.d.lc.filter(x => x.ia === true).map((pageObj, i) => {
                      // let objCountParams = {
                      //   pglkcnt: 0,
                      //   pgflcnt: 0,
                      //   pgrtngcnt: pageObj.totalReviewCount,
                      //   pgrtngavg: pageObj.averageRating,
                      //   pu: pageObj.placeID,
                      //   iin: usInt.inm,
                      //   rmk: pageObj.locationName,
                      //   dn: usInt.d.dn ? usInt.d.dn : ''
                      // };
                      // if (pageObj.isListen === true) {
                      //   return <div className="dataset-select-list" key={i}>
                      //     <div className="dataset-select-item">
                      //       <ContentLoader
                      //         height={200}
                      //         width={1750}
                      //         speed={2}
                      //         primaryColor="#fff"
                      //         secondaryColor="#eceef4"
                      //         key={key}
                      //       >
                      //         <rect x="10" y="40" rx="0" ry="0" width="150" height="150"></rect>
                      //         <rect x="220" y="40" rx="0" ry="0" width="1500" height="150"></rect>
                      //       </ContentLoader>
                      //     </div>
                      //   </div>;
                      // } else {
                      usInt.d['filData'] = pageObj;
                      return <div className="dataset-select-list" key={i}>
                        <div className="dataset-select-item">
                          {/* <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc">
                                <label>
                                  <input type="checkbox"
                                    name={pageObj.locationName}
                                    checked={arrDataSource.filter((dataSource) => {
                                      if (dataSource.uid == usInt._id && dataSource.pid == pageObj.name) return true; return false;
                                    }).length > 0 ? true : false}
                                    onChange={(e) => handleDataSource(
                                      usInt._id,
                                      pageObj.name,
                                      e.target.checked,
                                      objCountParams,
                                      usInt
                                    )}
                                  />
                                </label>
                              </div> */}
                          <h5>{pageObj.locationName}</h5>
                          {pageObj.isListen === true &&
                            <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                                <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                              </svg>
                            </span>
                          }
                          <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deletePageReview({ name: pageObj.name, _id: usInt._id })}>
                            <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                              <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                              <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                              <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                            </svg>
                          </span>
                          {!pageObj.isListen &&
                            <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt" style={{ display: 'none' }}
                              onClick={() => openReviewModel(usInt)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                                <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                              </svg>
                            </span>}
                        </div>
                      </div>;
                      // }
                    }) : <div className="dataset-select-list">
                      <div className="dataset-select-item">
                        <h5> No record found</h5>
                      </div>
                    </div>
                    }
                  </div>

                </div></div>);
            })
            : ''
      }
    </div>
  );
};

export default GoogleReview;


// WEBPACK FOOTER //
// ./src/components/Integration/GoogleReview.js